:host {
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  display:inline;
  height:100%;
  width:auto;
  overflow: hidden;
  visibility:hidden;
}

#overlaySizer{
  width:0px;
  height:0px;
  overflow:visible;
  display:none;
  visibility:hidden;
}

#timer{
  position:absolute;
  width:100%;
  height:100%;
  z-index:9000;
}
